module.exports = __webpack_public_path__ + "static/media/spinner.720cfc97.gif";